export function formatPlanPrice(plan: {
  price: number | null;
  price_label?: string;
  period?: string;
}): string {
  if (plan.price_label) {
    return plan.price_label;
  }
  if (plan.price === null) {
    return 'Custom';
  }
  if (plan.price === 0) {
    return 'Free';
  }
  return Number.isInteger(plan.price)
    ? `$${plan.price}`
    : `$${plan.price.toFixed(1)}`;
}

export function formatLimitValue(value: number | null | undefined): string {
  if (value === null || value === undefined) {
    return 'Unlimited';
  }
  return String(value);
}

export function isPaidPlan(plan: {
  price: number | null;
  price_label?: string;
}): boolean {
  if (plan.price_label) {
    return false;
  }
  return plan.price !== null && plan.price > 0;
}

export const PENDING_CHECKOUT_STORAGE_KEY = 'vioo_pending_checkout_session';
